/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { Program as e } from "./Program.js";

function n(e) {
  var n = "";

  for (var _t in e) {
    var o = e[_t];
    if ("boolean" == typeof o) o && (n += "#define ".concat(_t, "\n"));else if ("number" == typeof o) n += "#define ".concat(_t, " ").concat(o.toFixed(), "\n");else if ("object" == typeof o) {
      var _e = o.options;
      var r = 0;

      for (var _t2 in _e) {
        n += "#define ".concat(_e[_t2], " ").concat((r++).toFixed(), "\n");
      }

      n += "#define ".concat(_t, " ").concat(_e[o.value], "\n");
    }
  }

  return n;
}

function t(n, t, o, r) {
  o = o || {}, r = r || "";
  var f = "function" == typeof t.shaders ? t.shaders(o) : t.shaders;
  return new e(n, r + f.vertexShader, r + f.fragmentShader, t.attributes);
}

export { t as createProgram, n as glslifyDefineMap };